import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TyloJeevesCartListStateService {
  public cartListIsLoading = new BehaviorSubject<boolean>(undefined);

  constructor() {}

  public nextCartListIsLoading(orderForm: boolean) {
    return this.cartListIsLoading.next(orderForm);
  }
}
